module.exports = __webpack_public_path__ + "static/img/360js_img_3.92a34ddb.png";